import React from 'react';
import { useNavigate } from 'react-router-dom';

const Breadcrumb = () => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/');
  };

  return (
    <nav
      className="flex flex-col justify-center items-start px-4 py-2.5 w-full text-base text-center whitespace-nowrap bg-white rounded-xl shadow-2xl max-md:max-w-full"
      aria-label="Breadcrumb navigation"
    >
      <ol className="flex gap-1.5 justify-center items-center">
        <li className="flex gap-2.5 items-start self-stretch my-auto text-green-500">
          <button
            onClick={handleHomeClick}
            className="text-green-500 hover:underline focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 rounded"
            aria-current="page"
          >
            Home
          </button>
        </li>
        <li>
          <img
            src="https://api.builder.io/api/v1/image/assets/TEMP/8dd36cc4300533b24e71b89aa3e0f9841027c920?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
            alt=""
            className="object-contain shrink-0 self-stretch my-auto aspect-square w-[18px]"
            role="presentation"
          />
        </li>
        <li className="flex gap-2.5 items-start self-stretch my-auto text-zinc-500">
          <span>Wishlist</span>
        </li>
      </ol>
    </nav>
  );
};

export default Breadcrumb;
